jQuery(document).ready(function () {
  jQuery('.tolstoy-product-tile').hide();
  jQuery('.shopify-policy__body').addClass('privacy-policy-page');
jQuery('#shopify-section-template--24754433982782__main').addClass('account-page');
  jQuery('#shopify-section-template--24754434048318__main').addClass('account-page');
  jQuery('.why-dailysmile-button').addClass('whydaily-smile-btn')
  jQuery('.tolstoy-product-content').hide();
jQuery(window).scroll(function() {
    var sticky = jQuery('body'),
        scroll = jQuery(window).scrollTop();
    if (scroll >= 100) sticky.addClass('sticky_header');
    else sticky.removeClass('sticky_header');
});  

 jQuery('h2.majortitle.in-content.h1').html(function(_, oldHtml) {
  return oldHtml.replace(/(30,000\+)/, '<span class="grey-class">$1</span>');
});

});
$(document).ready(function() {

    // Define the validateEmail function first
    function validateEmail(email) {
        var regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        return regex.test(email);
    }

    // On clicking the newsletter button
    $("#newsletter-btn").on("click", function(e) {
        // Remove previous error messages
        $(".error_msg").remove();

        // Get the email value
        var email = $(".signup-form__email").val();

        // Check if the email is empty
        if (email === "") {
            e.preventDefault();
            $(".signup-form__email").addClass("error");
            $('<span class="error_msg">This field is required</span>').insertAfter(".signup-form__email");
        } 
        // Check if the email is valid
        else if (!validateEmail(email)) {
            e.preventDefault();
            $(".signup-form__email").addClass("error");
            $('<span class="error_msg">Please enter a valid email address.</span>').insertAfter(".signup-form__email");
        } 
        // If valid, remove the error class (if any)
        else {
            $(".signup-form__email").removeClass("error");
        }
    });

    // Real-time validation while typing in the email input
    $(".signup-form__email").on("input", function() {
        $(this).removeClass("error");
        $(this).siblings(".error_msg").remove();
    });

});
jQuery(document).ajaxComplete(function() {
  if (jQuery('.tolstoy-carousel.tolstoy-product-tile').length) {
    jQuery('.tolstoy-carousel.tolstoy-product-tile').hide();
  }
  if (jQuery('.tolstoy-carousel.tolstoy-product-content').length) {
    jQuery('.tolstoy-carousel.tolstoy-product-content').hide();
  }
});
$(document).ready(function() {
    // Interval for moving the slider (5 seconds in this case)
    const slideInterval = 2000; 
    
    // Select the element that controls the slider (carriage)
    const $sliderCarriage = $(".PairSliderDivisionControl__Carriage-sc-1niupp4-1");
    
    // Calculate how much to move the carriage each time (this will vary depending on your slider's width)
    const moveDistance = 462; // Adjust this value based on the length of your slider's width
    
    let currentPosition = 0;
    
    // Function to move the slider automatically
    function moveSlider() {
      currentPosition += moveDistance;
      
      // If we've reached the end of the slider, reset to the beginning
      if (currentPosition >= $sliderCarriage.width()) {
        currentPosition = 0;
      }
      
      // Move the carriage to the new position
      $sliderCarriage.css("transform", "translate(" + -currentPosition + "px, 0px)");
    }
    
    // Start the automatic sliding
    setInterval(moveSlider, slideInterval);
  });

// $(document).ready(function() {
//   // Check if there's an active link stored in sessionStorage
//   var activeLink = sessionStorage.getItem('activeLink');

//   if (activeLink) {
//     // If there's an active link, find the corresponding li and mark it as active
//     $('.navigation__item').removeClass('navigation__item--active');
//     $('.navigation__link[href="' + activeLink + '"]').closest('.navigation__item').addClass('navigation__item--active');
//   }

//   // When any anchor tag inside .navigation__item is clicked
//   $('.navigation__link').on('click', function(e) {
//     // Remove the 'navigation__item--active' class from all li elements
//     $('.navigation__item').removeClass('navigation__item--active');

//     // Add the 'navigation__item--active' class to the parent li of the clicked link
//     $(this).closest('.navigation__item').addClass('navigation__item--active');

//     // Store the href of the clicked link in sessionStorage
//     sessionStorage.setItem('activeLink', $(this).attr('href'));
//   });
// 



  $(document).ready(function () {
    const $shopMenuItem = $('.navigation__item--with-children');
    const $shopToggle = $shopMenuItem.find('.navigation__children-toggle');
    const currentPath = window.location.pathname;

    // Toggle Shop menu on click of arrow toggle
    $shopToggle.on('click', function (e) {
      e.preventDefault();

      // Remove active class from all first
      $('.navigation__item').removeClass('navigation__item--active');

      // Toggle active on Shop menu
      $shopMenuItem.toggleClass('navigation__item--active');
    });

    // On page load: find the submenu link that matches current URL
    $('.navigation__tier-2 a').each(function () {
      const linkPath = new URL(this.href).pathname;

      if (linkPath === currentPath) {
        const $submenuItem = $(this).closest('.navigation__item');
        $submenuItem.addClass('navigation__item--active'); // Add class to submenu item
        $shopMenuItem.addClass('navigation__item--active'); // Add class to Shop parent menu
        return false; // break out of .each()
      }
    });
  });
$(document).ready(function() {
    // Get the current URL
    var currentUrl = window.location.href;

    // Check if any submenu item matches the current URL on page load
    $('.navigation__tier-2 .navigation__item > a').each(function() {
        if (this.href === currentUrl) {
            // Add 'active' class to the clicked submenu item
            $(this).addClass('navigation__link--active');
            
            // Add 'active' class to the parent 'Shop' menu item
            $(this).closest('.navigation__tier-2').prev('.navigation__item').addClass('navigation__item--active');
        }
    });

    // On submenu item click
    $('.navigation__tier-2 .navigation__item > a').click(function() {
        // Remove 'active' class from all submenu items
        $('.navigation__tier-2 .navigation__item > a').removeClass('navigation__link--active');
        
        // Add 'active' class to the clicked submenu item
        $(this).addClass('navigation__link--active');

        // Set the parent 'Shop' menu as active
        $(this).closest('.navigation__tier-2').prev('.navigation__item').addClass('navigation__item--active');
    });
});



$(window).on('load', function() {
  // Default open state for the first section (custom description)
  $('.custom-description-content').first().addClass('show');
  $('.custom-description-btn').first().addClass('open').removeClass('close');

  // Ensure other sections are closed initially
  $('.custom-description-content').not(':first').removeClass('show');
  $('.custom-description-btn').not(':first').addClass('close').removeClass('open');

  // Event delegation for the custom description toggle
  $(document).on('click', '.custom-description-btn', function() {
    const content = $(this).next('.custom-description-content');
    content.toggleClass('show');

    // Add/remove open/close classes on the button
    if (content.hasClass('show')) {
      $(this).addClass('open').removeClass('close');
    } else {
      $(this).addClass('close').removeClass('open');
    }
  });

  // Event delegation for the what's in the kit toggle
  $(document).on('click', '.whats-in-kit-btn', function() {
    const content = $(this).next('.whats-in-kit-content');
    content.toggleClass('show');

    if (content.hasClass('show')) {
      $(this).addClass('open').removeClass('close');
    } else {
      $(this).addClass('close').removeClass('open');
    }
  });

  // Event delegation for the ingredients toggle
  $(document).on('click', '.ingredients-btn', function() {
    const content = $(this).next('.ingredients-content');
    content.toggleClass('show');

    if (content.hasClass('show')) {
      $(this).addClass('open').removeClass('close');
    } else {
      $(this).addClass('close').removeClass('open');
    }
  });
});



$(document).ready(function() {
  // Check if the current URL matches the specific product URL
   if (window.location.href.indexOf("/products/advanced-formula-teeth-whitening-kit") > -1) {
    $('.product-info-accordion').hide();
  }
});

jQuery(document).ready(function($) {
  const currentPath = window.location.pathname.replace(/\/+$/, ''); // normalize by removing trailing slash

  console.log('Current path:', currentPath); // for debugging

  $('.section-footer__menu-block__menu li').each(function() {
    const link = $(this).find('a');
    if (!link.length) return;

    // Create a temp anchor element to extract the pathname
    const linkPath = $('<a>')
      .prop('href', link.attr('href'))
      .prop('pathname')
      .replace(/\/+$/, ''); // normalize

    console.log('Checking against link path:', linkPath); // for debugging

    if (linkPath === currentPath) {
      $('.section-footer__menu-block__menu li').removeClass('active'); // remove from all
      $(this).addClass('active'); // add to matched one
    }

    // Optional: also update on click
    link.on('click', function() {
      $('.section-footer__menu-block__menu li').removeClass('active');
      $(this).closest('li').addClass('active');
    });
  });
});

// $(document).ready(function() {
//     $('.majortitle').each(function() {
//         // Get the HTML content of the h2 element
//         var content = $(this).html();
        
//         // Check if the word 'Eliminate' is in the content
//         if(content.indexOf('Eliminate') !== -1) {
//             // Insert <br> after the word 'Eliminate'
//             var updatedContent = content.replace('Eliminate', 'Eliminate<br>');
//             $(this).html(updatedContent);
//         }
//     });
// });
$(document).ready(function() {
    $('P').each(function() {
        // Get the HTML content of the h2 element
        var content = $(this).html();
        
        // Check if the word 'Eliminate' is in the content
        if(content.indexOf('Whiter') !== -1) {
            // Insert <br> after the word 'Eliminate'
            var updatedContent = content.replace('Whiter', 'Whiter<br>');
            $(this).html(updatedContent);
        }
    });
});
// $(document).ready(function() {
//     var stickyButton = $('.add-to-cart');
//     var offset = stickyButton.offset().top; // Get the button's initial position

//     // When the page scrolls
//     $(window).scroll(function() {
//         if ($(window).scrollTop() > offset) {
//             stickyButton.addClass('sticky');
//         } else {
//             stickyButton.removeClass('sticky');
//         }
//     });
// });
